<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Documents" />
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                                data-original-title="test" data-bs-target="#documentsAdd">Add Documetns</button>
                        </div>
                        <div class="card-body badge-spacing">
                            <div class="table-responsive custom-scrollbar">
                                <table class="table display" id="basic-1">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr  v-for="(item ,index)  in documents" :key="item.id" >
                                            <td>{{item.name}}</td>
                                            <td>{{(item.status==1)?'Active':'De-Active'}}</td>
                                            <td>
                                                <ul class="action">
                                                    <li class="edit" @click="edit_documents(item)"><i class="icon-pencil-alt"></i></li>
                                                    <li class="delete" @click="remove_document(item.id)"><i class="icon-trash"></i></li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->

    <ModalsPart v-if="!['login'].includes($route.name)" @getDocuemtsData="updateData" :edit_document_row="edit_document_row" />
</template>

<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import axios from 'axios';
const config = {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded"
            },
            responseType: 'json'
         };
export default {
    name: 'Rooms', 
    components: {
        PageTitle, ModalsPart
    }, mounted() {
        this.getBasics();

    }, data() {
        return {
            documents: [],
            edit_document_row: []
        }
    },
    methods: {
        updateData(value) {
            this.documents = value;
        },
        getBasics() {
            var self = this;
            axios.post('getDocuments', config).then(function (response) {
                self.documents = response.data.documents; 
                window.scrollTo(0, 0);
            });
        },
        remove_document(id) {
            var self = this;
            axios.post('removeDocument', {document_id:id}).then(function (response) {
                self.documents = response.data.documents; 
                window.scrollTo(0, 0);
            });
        }, 
        edit_documents(item) {
            var self = this;
            self.edit_document_row=item;
            $("#documentsAdd").modal("toggle");
           
        }
       
    }
}
</script>
